<!-- <template>
  <div class="welcome-item">
    <i>
      <slot name="icon"></slot>
    </i>
    <div class="details">
      <h3>
        <slot name="heading"></slot>
      </h3>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.welcome-item {
  margin-top: 0;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  transition: transform 0.2s, box-shadow 0.2s;
}

.welcome-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.details {
  flex: 1;
  margin-left: 1.5rem;
}

i {
  display: flex;
  place-items: center;
  place-content: center;
  width: 48px;
  height: 48px;
  color: #2e7d32;
  font-size: 1.5rem;
}

h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #1b5e20;
}

a {
  color: #2e7d32;
  font-weight: 500;
  text-decoration: underline;
}

@media (min-width: 1024px) {
  .welcome-item {
    padding: 2rem;
  }

  i {
    width: 56px;
    height: 56px;
    font-size: 1.75rem;
  }

  h3 {
    font-size: 1.5rem;
  }
}
</style> -->


<!-- <template>
  <div class="welcome-item hover-3d">
    <slot name="icon"></slot>
    <div class="details">
      <h3>
        <slot name="heading"></slot>
      </h3>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.welcome-item {
  @apply glass-card bg-white/70 p-6 rounded-2xl shadow-lg transition-all duration-300;
  backdrop-filter: blur(10px);
}

.welcome-item:hover {
  @apply shadow-xl;
}

.details {
  @apply mt-4;
}

h3 {
  @apply text-xl font-bold text-gray-800 mb-3;
}

a {
  @apply text-green-600 hover:text-green-800 transition-colors;
}
</style> -->

<template>
  <div class="welcome-item hover-3d">
    <slot name="icon"></slot>
    <div class="details">
      <h3>
        <slot name="heading"></slot>
      </h3>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.welcome-item {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.welcome-item:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.details {
  margin-top: 1rem;
}

h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.75rem;
}

a {
  color: #059669;
  transition: color 0.2s ease;
}

a:hover {
  color: #047857;
}
</style>
